module.exports = __webpack_public_path__ + "img/keyboard_arrow_down-white-18dp.1cd146fe.svg";